"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/typeof"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _moment = _interopRequireDefault(require("react-day-picker/moment"));
var _hiLocaleUtils = _interopRequireDefault(require("./hiLocaleUtils"));
var _DayPickerInput = _interopRequireDefault(require("react-day-picker/DayPickerInput"));
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _Caption = _interopRequireDefault(require("./Caption"));
var _Overlay = _interopRequireDefault(require("./Overlays/Overlay"));
var _TimePickerOverlay = _interopRequireDefault(require("./Overlays/TimePickerOverlay"));
var _MonthPickerOverlay = _interopRequireDefault(require("./Overlays/MonthPickerOverlay"));
var _YearPickerOverlay = _interopRequireDefault(require("./Overlays/YearPickerOverlay"));
var _NavBar = _interopRequireDefault(require("./NavBar"));
var _Weekday = _interopRequireDefault(require("./Weekday"));
var _HiTextField = _interopRequireDefault(require("../HiForm/HiTextField"));
var _stylesheet = _interopRequireDefault(require("./stylesheet"));
var _reactDeviceDetect = require("react-device-detect");
var _HiDatePickerMobile = _interopRequireDefault(require("./HiDatePickerMobile"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HiDatePicker = /*#__PURE__*/function (_React$Component) {
  function HiDatePicker(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiDatePicker);
    _this = _callSuper(this, HiDatePicker);
    _this.handleInputChange = function (event) {
      _this.props.onChange(event.target.value);
    };
    _this.handleKeyDown = function (name) {
      return function (event) {
        if (event.key === 'Escape' && !event.shiftKey) {
          _this.datePickerInput.hideDayPicker();
          event.stopPropagation();
        }
      };
    };
    _this.handleReset = function () {
      var today = (0, _momentTimezone.default)();
      _this.handleCurrentMonthChange(new Date(today.year(), today.month(), today.date(), today.hours(), today.minutes(), today.seconds(), today.milliseconds()));
      _this.props.onReset();
    };
    _this.handleDayChange = function (day, modifiers) {
      if (day) {
        if (modifiers.selected) {
          // Deselect day
          _this.props.onChange(undefined);
        } else {
          // Keep Time if set
          if (_this.props.enableTime) {
            if (_this.props.value) {
              day.setHours(_this.props.value.getHours(), _this.props.value.getMinutes());
            } else {
              day.setHours(0, 0);
            }
          }
          _this.props.onChange(day);
        }
        if (day instanceof Date && !_this.props.enableTime && modifiers.selected !== true) {
          // Hide overlay & remove focus on input
          document.activeElement.blur();
        } else if (day instanceof Date && _this.props.enableTime && modifiers.selected !== true) {
          // Open Time panel after date selection
          _this.openPanel('time');
        }
      }
    };
    _this.handleChangeMobile = function (event) {
      var date;
      if (event.target.value) {
        date = new Date(event.target.value);
      }
      _this.props.onChange(date);
    };
    _this.handleCalendarClick = function () {
      _this.openPanel('calendar');
    };
    _this.handleClockClick = function () {
      _this.openPanel('time');
    };
    _this.handleMonthClick = function () {
      _this.openPanel('months');
    };
    _this.handleYearClick = function () {
      _this.openPanel('years');
    };
    _this.handleCurrentMonthChange = function (day) {
      _this.setState({
        // Current Month can't be anterior to minimumDate
        currentMonth: day < _this.props.minimumDate ? _this.props.minimumDate : day,
        openedPanel: 'calendar'
      });
    };
    _this.handleTimeChange = function (date, precision) {
      _this.props.onChange(date);
      if (date instanceof Date && precision === 'minute') {
        document.activeElement.blur();
      }
    };
    _this.openPanel = function (panel) {
      _this.setState({
        openedPanel: panel
      });
    };
    _this.renderCaption = function (propsCaption) {
      return /*#__PURE__*/_react.default.createElement(_Caption.default, (0, _extends2.default)({
        onMonthClick: _this.handleMonthClick,
        onYearClick: _this.handleYearClick
      }, propsCaption));
    };
    _this.renderOverlay = function (propsOverlay) {
      switch (_this.state.openedPanel) {
        case 'time':
          return _this.renderTimePickerOverlay(propsOverlay);
        case 'months':
          return _this.renderMonthPickerOverlay(propsOverlay);
        case 'years':
          return _this.renderYearPickerOverlay(propsOverlay);
        case 'calendar':
        default:
          return /*#__PURE__*/_react.default.createElement(_Overlay.default, propsOverlay);
      }
    };
    _this.renderMonthPickerOverlay = function (propsOverlay) {
      var monthPickerProps = {
        value: _this.state.currentMonth,
        onChange: _this.handleCurrentMonthChange
      };
      return /*#__PURE__*/_react.default.createElement(_MonthPickerOverlay.default, (0, _extends2.default)({
        key: 'month-picker-overlay'
      }, monthPickerProps, propsOverlay));
    };
    _this.renderTimePickerOverlay = function (propsOverlay) {
      var timePickerProps = {
        value: _this.props.value,
        onChange: _this.handleTimeChange,
        onCalendarClick: _this.handleCalendarClick
      };
      return /*#__PURE__*/_react.default.createElement(_TimePickerOverlay.default, (0, _extends2.default)({
        key: 'time-picker-overlay'
      }, timePickerProps, propsOverlay));
    };
    _this.renderYearPickerOverlay = function (propsOverlay) {
      var yearPickerProps = {
        value: _this.state.currentMonth,
        onChange: _this.handleCurrentMonthChange,
        disableFutureDays: _this.props.disableFutureDays,
        minimumDate: _this.props.minimumDate
      };
      return /*#__PURE__*/_react.default.createElement(_YearPickerOverlay.default, (0, _extends2.default)({
        key: 'year-picker-overlay'
      }, yearPickerProps, propsOverlay));
    };
    var _today = (0, _momentTimezone.default)();
    _this.state = {
      openedPanel: 'calendar',
      currentMonth: props.value ? props.value : new Date(_today.year(), _today.month(), _today.date(), _today.hours(), _today.minutes(), _today.seconds(), _today.milliseconds())
    };
    return _this;
  }
  (0, _inherits2.default)(HiDatePicker, _React$Component);
  return (0, _createClass2.default)(HiDatePicker, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        disabledDays = _this$props.disabledDays,
        disablePastDays = _this$props.disablePastDays,
        disableFutureDays = _this$props.disableFutureDays,
        enableTime = _this$props.enableTime,
        format = _this$props.format,
        locale = _this$props.locale,
        minimumDate = _this$props.minimumDate,
        onReset = _this$props.onReset,
        translations = _this$props.translations,
        value = _this$props.value,
        hideOnDayClick = _this$props.hideOnDayClick,
        HiInputProps = _this$props.HiInputProps,
        props = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "disabledDays", "disablePastDays", "disableFutureDays", "enableTime", "format", "locale", "minimumDate", "onReset", "translations", "value", "hideOnDayClick", "HiInputProps"]);
      var currentMonth = this.state.currentMonth;
      var today = (0, _momentTimezone.default)();
      var effectiveDisabledDays = (0, _objectSpread2.default)({}, disablePastDays && {
        before: new Date(today.year(), today.month(), today.date(), today.hours(), today.minutes(), today.seconds(), today.milliseconds())
      }, {}, disableFutureDays && {
        after: new Date(today.year(), today.month(), today.date(), today.hours(), today.minutes(), today.seconds(), today.milliseconds())
      }, {}, disabledDays);
      var modifiersStyles = {
        selected: {
          borderRadius: '50%'
        }
      };
      var dayPickerProps = (0, _objectSpread2.default)({
        todayButton: translations.today,
        onTodayButtonClick: this.handleCurrentMonthChange,
        weekdayElement: _Weekday.default,
        navbarElement: function navbarElement(props2) {
          return /*#__PURE__*/_react.default.createElement(_NavBar.default, (0, _extends2.default)({
            showClockButton: enableTime,
            onClockClick: _this2.handleClockClick
          }, props2, {
            localeUtils: _hiLocaleUtils.default
          }));
        },
        captionElement: this.renderCaption,
        classNames: classes,
        disabledDays: effectiveDisabledDays,
        selectedDays: (0, _typeof2.default)(value) === 'object' ? value : undefined,
        firstDayOfWeek: 1,
        fromMonth: minimumDate,
        modifiers: (0, _defineProperty2.default)({
          disabled: effectiveDisabledDays,
          selected: value
        }, classes.currentDay, new Date(today.year(), today.month(), today.date(), today.hours(), today.minutes(), today.seconds(), today.milliseconds())),
        modifiersStyles: modifiersStyles,
        month: currentMonth
      }, props, {
        locale: locale,
        localeUtils: _hiLocaleUtils.default
      });
      var inputProps = (0, _objectSpread2.default)({}, onReset && {
        onReset: this.handleReset
      }, {}, props, {
        onChange: this.handleInputChange,
        HiInputProps: {
          onSubmit: this.props.onSubmit
        }
      });
      if (typeof HiInputProps !== "undefined") {
        inputProps.HiInputProps = (0, _objectSpread2.default)({}, inputProps.HiInputProps, {}, HiInputProps);
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root,
        onKeyDown: this.handleKeyDown()
      }, !_reactDeviceDetect.isMobile ? /*#__PURE__*/_react.default.createElement(_DayPickerInput.default, {
        ref: function ref(el) {
          _this2.datePickerInput = el;
        },
        value: value,
        hideOnDayClick: hideOnDayClick,
        overlayComponent: this.renderOverlay,
        dayPickerProps: dayPickerProps,
        component: _HiTextField.default,
        inputProps: inputProps,
        placeholder: '',
        format: enableTime ? "".concat(format, " HH:mm") : format,
        formatDate: _moment.default.formatDate,
        parseDate: _moment.default.parseDate,
        onDayChange: this.handleDayChange
      }) : /*#__PURE__*/_react.default.createElement(_HiDatePickerMobile.default, {
        id: this.props.id,
        label: this.props.label,
        required: this.props.required,
        disabled: this.props.disabled,
        error: this.props.error,
        errorText: this.props.errorText,
        helperText: this.props.helperText,
        helperIcon: this.props.helperIcon,
        enableTime: enableTime,
        value: value,
        onChange: this.handleChangeMobile,
        disablePastDays: disablePastDays,
        disableFutureDays: disableFutureDays,
        today: today,
        minimumDate: minimumDate,
        format: enableTime ? "".concat(format, " HH:mm") : format
      }));
    }
  }]);
}(_react.default.Component);
HiDatePicker.defaultProps = {
  disabledDays: [],
  disablePastDays: false,
  disableFutureDays: false,
  enableTime: false,
  format: 'YYYY-DD-MM',
  hideOnDayClick: false,
  locale: 'fr-FR',
  minimumDate: new Date(2013, 4, 1),
  // by default 1 May 2013
  translations: {
    today: 'today'
  }
};
var _default = exports.default = (0, _withStyles.default)(_stylesheet.default, {
  name: 'HmuiHiDatePicker'
})(HiDatePicker);